import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';

import { AuthService } from 'app/services/auth.service';
import { CreateRestService } from 'app/services/create.rest.service';
import { User } from 'fitforce-document-sync';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  animations: [
    trigger('fade', [
      state('void', style({ opacity: 0, transform: 'translateY(-100%)' })),
      transition('void <=> *', [animate('0.5s 0s ease-in-out')]),
    ]),
  ],
})
export class FeedbackComponent implements OnInit, OnDestroy {
  @Input() disabled = false;

  feedback = '';
  inputValid = true;
  successMessage = false;
  errorMessage = false;
  currentUser: User;
  currentUserSub: Subscription = new Subscription();

  constructor(private createRestService: CreateRestService, private authService: AuthService) {}

  ngOnInit() {
    this.currentUserSub = this.authService.currentUserObs.subscribe(user => {
      this.currentUser = user;
    });
  }

  ngOnDestroy(): void {
    this.currentUserSub.unsubscribe();
  }

  submitFeedback(fb) {
    const self = this;
    if (fb.length < 3) {
      self.inputValid = false;
      setTimeout(function() {
        self.inputValid = true;
      }, 3000);
    } else {
      this.feedback = '';
      this.inputValid = true;

      forkJoin([
        this.createRestService.submitFeedback(fb),
        // this.createRestService.submitFeedbackExternal(
        //   fb,
        //   this.currentUser.firstName,
        //   this.currentUser.lastName,
        //   this.currentUser.email,
        //   this.currentUser.rank,
        // ),
      ]).subscribe(
        response => {
          self.successMessage = true;
          setTimeout(function() {
            self.successMessage = false;
          }, 3000);
        },
        error => {
          self.errorMessage = true;
          setTimeout(function() {
            self.errorMessage = false;
          }, 3000);
        },
      );
    }
  }
}
